import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const Pharmacy = () => {
  return (
    <section id="pharmacy-management" className="landing pharmacy-landing">
      <Helmet>
        <title>Pharmacy Management Software India — Mediway Nextgen</title>
        <meta name="description" content="Pharmacy Management Software for hospitals and clinics in India — drug inventory, prescription dispensing, expiry alerts, GST billing, and NABH-compliant workflows by Mediway Nextgen." />
        <link rel="canonical" href="https://mediwaynextgen.wayug.com/services/pharmacy-management-software" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Product',
            'name': 'Pharmacy Management Software',
            'description': 'Hospital pharmacy management with drug inventory, prescription dispensing, expiry tracking, GST billing and NABH-compliant workflows for Indian hospitals.',
            'brand': 'Mediway Nextgen',
            'url': 'https://mediwaynextgen.wayug.com/services/pharmacy-management-software'
          })}
        </script>
      </Helmet>

      <div className="container">
        <header className="section-header">
          <h2 className="section-title">Pharmacy Management Software — Smart Hospital Dispensing</h2>
          <p className="section-subtitle">Complete pharmacy operations for hospital pharmacies — prescription dispensing, drug inventory, expiry tracking and GST-compliant billing built for India.</p>
        </header>

        <div className="service-content">
          <div className="service-header">
            <div className="service-icon">💊</div>
            <div className="service-info">
              <h3 className="service-title">Intelligent Pharmacy Operations</h3>
              <p className="service-description">Automate prescription workflows, maintain real-time drug stock, control expiry alerts, and generate GST-compliant invoices — all connected directly to the patient's clinical record.</p>
            </div>
          </div>

          <div className="service-body">
            <div className="service-features">
              <h4>Key Features</h4>
              <ul className="features-list">
                <li className="feature-item"><span className="feature-check">✓</span><span>Prescription dispensing &amp; e-prescription support</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Drug inventory with batch &amp; expiry tracking</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Automatic reorder alerts &amp; purchase orders</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>GST-compliant billing &amp; HSN code support</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Integration with OPD, IPD &amp; billing modules</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Drug interaction &amp; allergy alerts</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>NABH pharmacy standard workflows</span></li>
              </ul>
            </div>

            <div className="service-benefits">
              <h4>Benefits</h4>
              <div className="benefits-grid">
                <div className="benefit-card"><div className="benefit-icon">📦</div><span>Zero stock-outs</span></div>
                <div className="benefit-card"><div className="benefit-icon">🛡️</div><span>Reduce medication errors</span></div>
                <div className="benefit-card"><div className="benefit-icon">💰</div><span>Accurate GST billing</span></div>
                <div className="benefit-card"><div className="benefit-icon">🔗</div><span>Linked to patient records</span></div>
              </div>
            </div>
          </div>

          <div className="service-actions">
            <Link to="/contact" className="btn btn-primary">Request Pharmacy Demo</Link>
            <Link to="/services" className="btn btn-secondary">All Services</Link>
          </div>
        </div>
      </div>

      <div className="services-background">
        <div className="background-pattern"></div>
      </div>
    </section>
  );
};

export default Pharmacy;
